// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { searchBoxStyles } from "@awc/Overrides/Widgets/MyLists/MyListsSearchBox";
import Search from "@awc/XDL/Icons/Search";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

searchBoxStyles.search = {
    mergeCss: true,
    cssOverrides: {
        formInputWrapper: css`
            width: 100%;
            ${IconWrapper} {
                top: 1px;
            }
        `,
        formField: css`
            flex: 1;
        `,
        inputSelect: css`
            padding: 0 24px 0 28px;
            &:focus {
                padding: 0 24px 0 28px;
            }
        `,
    },
    iconProps: {
        src: Search,
        size: 16,
    },
    leftAlignIcon: true,
};
